import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NavigationBar from "../components/NavigationBar.js";
import axios from "axios";
import { useTheme } from "../../ThemeContext.js";
import translations from "../../translate.js";
import "../../styles/authForm.scss";

function LoginPageBrowser({ onLogin }) {
    const navigate = useNavigate();
    const language = localStorage.getItem("language") || "lv";
    const text = translations[language];
    const { theme } = useTheme();

    const [formData, setFormData] = useState({
        first_name: "", // Izmanto vārdu
        telegram_user_id: "", // Telegram ID kā "parole"
    });

    const [errorMessage, setErrorMessage] = useState("");
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoggingIn(true);
        setErrorMessage("");

        console.log("Sending login request with:", {
            first_name: formData.first_name,
            telegram_user_id: formData.telegram_user_id,
        });

      try {
    const response = await axios.post(
        "/auth/dev-login",
        {
            first_name: formData.first_name,
            telegram_user_id: formData.telegram_user_id,
        },
        {
            headers: {
                "Content-Type": "application/json",
                language,
            },
            withCredentials: true,
        }
    );

    console.log("Login response:", response.data);

    if (response.status === 200) {
    onLogin();
    // const redirectTo = response.data.redirect || "/admin";
    navigate("/admin"); // ✅
}

} catch (error) {
    console.error("Login error:", error.response?.data || error.message);
    setIsLoggingIn(false);
    setErrorMessage(error.response?.data?.message || text.loginErrorInvalidDetails);
}

    };

    return (
        <div data-theme={theme}>
            <NavigationBar />
            <div className="container-fluid" id="form-container">
                <div className="card">
                    <div className="card-body">
                        <h2 className="text-uppercase text-center" id="login-title">
                            {text.logins}
                        </h2>

                       <form onSubmit={handleSubmit}>
                        <div className="form-outline">
                            <label className="form-label">{text.usernameLabel}</label>
                            <input
                                type="text"
                                className="form-control"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                placeholder={text.usernamePlaceholder}
                                required
                            />
                        </div>

                        <div className="form-outline">
                            <label className="form-label">{text.passwordLabel}</label>
                            <input
                                type="password"
                                className="form-control"
                                name="telegram_user_id"
                                value={formData.telegram_user_id}
                                onChange={handleChange}
                                placeholder={text.passwordPlaceholder}
                                required
                            />
                        </div>

                        <div className="d-flex justify-content-center" id="btn-container">
                            <button type="submit" className="btn" id="btn-form-submit" disabled={isLoggingIn}>
                                {isLoggingIn ? text.loggingIn : text.logins}
                            </button>
                        </div>

                        {errorMessage && <div className="error-message text-center mt-3">{errorMessage}</div>}
                    </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPageBrowser;